import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../config/design/styles";
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class TableBuilderDialog extends React.Component{
    state = {
        open: true,
        url:'',
        code:'',
        shortcode:'',
    };
    classes = this.props.classes;

    handleSetProduct(){
        let {shortcode} = this.state;
        this.props.setProduct(shortcode);
        this.props.cancleOperation();
    }
    handleClose = () => {
        this.setState({
            open:false
        });
        this.props.cancleOperation();
    };
    async handleChange(url){
        let split = url.split('/');
        let res = split[split.length - 1];
        let code = res.split('?')[0];
        let shortcode = `[[SHOWBOOK_#${code}]]`
        await this.setState({
            url,
            code,
            shortcode
        })
    }
    render(){
        let {open,url} = this.state;
        return(
            <div>
                <Dialog fullWidth={true} maxWidth={"xs"} open={open} onClose={this.handleClose} TransitionComponent={Transition} >
                    <AppBar className={this.classes.appBarDialog}>
                        <Toolbar>
                            <Typography variant="h6" className={this.classes.titleDialog}>
                                {Translate.productInsert}
                            </Typography>
                            <IconButton color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <div style={{padding:20}}>
                        <TextField
                            autoFocus
                            fullWidth
                            margin={"normal"}
                            variant="outlined"
                            label={Translate.productUrl}
                            placeholder={Translate.productSample}
                            value={url}
                            onChange={(e) => this.handleChange(e.target.value)}
                        />
                        <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            onClick={() => this.handleSetProduct()}
                        >
                            {Translate.productInsert}
                        </Button>
                    </div>
                </Dialog>
            </div>
        )
    }
}
export default  withStyles(Styles)(TableBuilderDialog)